// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BankRaifaizenPure = createIcon(
  <svg width="52" height="50" viewBox="0 0 52 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      fill="#000"
      opacity=".2"
      clipRule="evenodd"
      d="M1.31384 52.1138L10.5563 61.5354L32.211 39.5648L54.5902 61.988L63.9678 52.7016L41.8133 30.5503L46.0723 26.428V17.6398L48.7455 15.3752V22.2602L52.1889 25.0686L62.4716 14.7858L65.7782 17.3223C67.727 10.1198 56.4462 -6.23396 47.1142 2.82616L36.2405 13.6071L38.4611 16.2804L32.9339 21.6709L27.589 16.4155L30.3974 13.8774L18.4833 2.37193C9.51434 -5.01292 0.31747 6.2239 0 17.1856L3.26099 14.4684L13.2719 25.251L16.8503 22.2619V15.6471L19.0694 17.3223V25.9754L23.4179 30.324L1.31384 52.1138Z"
    ></path>
  </svg>,
);

export const BankRaifaizenIcon: React.SFC<{ iconClassName?: string; style?: React.CSSProperties }> = props => (
  <BankRaifaizenPure className={props.iconClassName} style={props.style} />
);

BankRaifaizenIcon.displayName = 'BankDomRfIcon';
